<template>
    <div class="card">
        <div v-if="item.messageLine1 == 'กรมธรรม์ประกันภัยรถยนต์'">
            <div>
                <div class="font-medium text-a-black-555555 text-base pb-1.5">
                    {{item.messageLine1}}
                </div>
                <div class="text-desc flex items-center gap-4">
                    <div class="flex-none leading-4.5">เลขที่กรมธรรม์</div>
                    <div class="flex-auto leading-4.5">
                        {{item.messageLine2?item.messageLine2.replace('เลขที่',''):''}}
                    </div>
                </div>

                <div class="mt-2.5 border-b border-a-gray-d0d0ce"></div>

                <div class="pt-4 text-desc-light grid grid-cols-1 gap-2">
                    <div class="flex justify-between leading-4.5">
                        <div>
                            ทะเบียน
                        </div>
                        <div>
                            {{item.messageLine3?item.messageLine3.replace('ทะเบียน',''):''}}
                        </div>
                    </div>
                    <div class="flex justify-between leading-4.5">
                        <div>
                            วันสิ้นสุดความคุ้มครอง
                        </div>
                        <div>
                            {{getDateFormat()}}
                            <!-- 1 ก.ค. 2563 -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else>
            <div class="font-medium text-a-black-555555 text-base pb-1.5">
                {{item.messageLine1}}
            </div>
            <div class="text-desc flex items-center gap-4">
                <div class="flex-none leading-4.5">เลขที่กรมธรรม์</div>
                <div class="flex-auto leading-4.5">
                    {{item.messageLine2?item.messageLine2.replace('เลขที่',''):''}}
                </div>
            </div>

            <div class="mt-2.5 border-b border-a-gray-d0d0ce"></div>

            <div class="pt-4 text-desc-light grid grid-cols-1 gap-2">
                <div class="flex justify-between leading-4.5">
                    <div>
                        วันสิ้นสุดความคุ้มครอง
                    </div>
                    <div>
                        {{getDateFormat()}}
                        <!-- 1 ก.ค. 2563 -->
                    </div>
                </div>
            </div>
        </div>

        <div class="pt-4" v-if="item.messageLine1 == 'กรมธรรม์ประกันภัยรถยนต์'">
            <div class="flex justify-between items-center text-desc-light leading-4.5">
                <div>
                    ค่าเบี้ยประกัน
                </div>
                <div>
                    <span class="font-medium text-15">{{item.messageLine6?item.messageLine6.replace('ค่าเบี้ยประกันภัย ','').replace(' บาท',''):''}}</span> บาท
                </div>
            </div>
            <div class="mt-6">
                <MainButton block class="h-12" @click="clickRenewal">
                    <div class="leading-6">ชำระค่าเบี้ย</div>
                </MainButton>
            </div>
            <div class="mt-1.5 text-desc-light text-center">
                <div class="leading-4.5">ขออภัยหากท่านชำระแล้ว</div>
            </div>
        </div>

        <div class="pt-4" v-else>
            <div class="flex justify-between items-center text-desc-light leading-4.5">
                <div>
                    ค่าเบี้ยประกัน
                </div>
                <div>
                    <span class="font-medium text-15">{{item.messageLine5?item.messageLine5.replace('ค่าเบี้ยประกันภัย ','').replace(' บาท',''):''}}</span> บาท
                </div>
            </div>
            <div class="mt-6">
                <MainButton block class="h-12" @click="clickRenewal">
                    <div class="leading-6">ชำระค่าเบี้ย</div>
                </MainButton>
            </div>
            <div class="mt-1.5 text-desc-light text-center">
                <div class="leading-4.5">ขออภัยหากท่านชำระแล้ว</div>
            </div>
        </div>
    </div>
</template>

<script>
import MainButton from '@/components/Button/MainButton.vue';
import { defineComponent } from 'vue';
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import { useTracking } from "@/feature/TrackingFeature"
import RenewalService from '../service/RenewalService';
import { useRoute } from 'vue-router';

export default defineComponent({
    props: {
        item: {
            type: Object
        },
        channel: {
            type: String,
        }
    },
    setup: function (props) {
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()
        const route = useRoute()

        const getDateFormat = function () {
            let dateStr = '';
            if (props.item.messageLine1 == 'กรมธรรม์ประกันภัยรถยนต์') {
                dateStr = props.item.messageLine5?props.item.messageLine5.replace('จะหมดอายุวันที่ ',''):'';
            } else {
                dateStr = props.item.messageLine4?props.item.messageLine4.replace('จะหมดอายุวันที่ ',''):'';
            }
            if (dateStr && dateStr.indexOf("/") != -1){
                let tmp = dateStr.split("/");
                let newDateStr = tmp[1] + "/" + tmp[0] + "/"+ tmp[2];
                let dateObj = new Date(newDateStr);
                return DatetimeHelper.dateShortFormatThai(dateObj);
            }
            return ;
        }

        const clickRenewal = async function () {
            tracking.event("renewal_list_page", "click_renew_pay_premium", "", "");
            let query = route.query || null
            // console.log(query)
            await updateFlowType(props.channel, props.item.rowKey, query);
            if (props.item.link) {
                window.location.replace(props.item.link);
            }
        }

        const updateFlowType = function(channel, paymentRef, query) {
            return new Promise((resolve, reject) => {
                RenewalService.updateFlowTypeToTniPolicyRenewal(channel, paymentRef, query).subscribe({
                    next: (res) => {
                        console.log(res)
                        resolve(true)
                    },
                    error: (err) => {
                        reject(err)
                    }
                })
            })
        }


        return {
            getDateFormat,
            clickRenewal,
        }
    },
    components: { MainButton }
})
</script>

<style lang="scss" scoped>
.card {
    border-radius: 13px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);
    @apply bg-white flex flex-col min-w-0 py-5 px-4 divide-y divide-a-gray-d0d0ce gap-4 font-main;

    .text-desc {
        @apply font-medium text-12 text-a-black-484848;
    }

    .text-desc-light {
        @apply font-light text-12 text-a-black-484848;
    }
}
</style>
